import * as tslib_1 from "tslib";
import { Location } from '@angular/common';
import { PipeTransform } from '@angular/core';
import { Messenger } from './services/messenger';
import { Data } from './services/data';
import { normalizeString } from './services/util';
import { PersonalInfoComponent } from './personal-info.component';
var SeederComponent = /** @class */ (function () {
    function SeederComponent(location, messenger, data) {
        this.location = location;
        this.messenger = messenger;
        this.data = data;
        this.tables = [];
        this.userSaved = false;
    }
    SeederComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var worker;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.data.hasBeenSeeded()];
                    case 1:
                        if (_a.sent()) {
                            this.tables = this.data.seedTableNames().map(function (n) { return ({ table: n, state: 'complete', target: 100, value: 100 }); });
                            return [2 /*return*/];
                        }
                        else {
                            this.tables = this.data.seedTableNames().map(function (n) { return ({ table: n, state: 'pending', target: 100, value: 0 }); });
                        }
                        try {
                            worker = new Worker('./assets/worker.js');
                        }
                        catch (e) {
                            console.error('error creating worker', e);
                        }
                        worker.onmessage = function (msg) {
                            var _a = msg.data, event = _a.event, table = _a.table, target = _a.target, value = _a.value;
                            var idx = _this.tables.findIndex(function (t) { return t.table == table; });
                            switch (event) {
                                case 'fetching':
                                    _this.tables[idx] = Object.assign({}, _this.tables[idx], { table: table, target: target, value: value, state: 'fetching' });
                                    break;
                                case 'seeding':
                                case 'starting-seed':
                                    _this.tables[idx] = Object.assign({}, _this.tables[idx], { value: (value / target) * 100, state: 'inserting' });
                                    break;
                                case 'clearing':
                                    _this.tables[idx] = Object.assign({}, _this.tables[idx], { state: 'clearing' });
                                    break;
                                case 'complete':
                                    _this.tables[idx] = Object.assign({}, _this.tables[idx], { state: 'complete' });
                                    break;
                                case 'all-complete':
                                    if (_this.userSaved) {
                                        _this.allComplete();
                                    }
                                    break;
                                case 'error':
                                    console.error('error seeding database', msg.data.error);
                                    _this.messenger.send('error seeding database', true);
                                    break;
                            }
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    SeederComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.personalInfo.onSave.subscribe(function () { return _this.onUserSaved(); });
    };
    SeederComponent.prototype.onUserSaved = function () {
        this.userSaved = true;
        if (this.tables.findIndex(function (t) { return t.state != 'complete'; }) < 0) {
            this.allComplete();
        }
    };
    SeederComponent.prototype.allComplete = function () {
        if (this.location.isCurrentPathEqualTo('/seed')) {
            this.location.back();
        }
    };
    return SeederComponent;
}());
export { SeederComponent };
var StatePipe = /** @class */ (function () {
    function StatePipe() {
    }
    StatePipe.prototype.transform = function (value) {
        switch (value) {
            case 'complete':
                return 'Complete';
            case 'inserting':
                return 'Inserting values into database';
            case 'fetching':
                return 'Getting data from server';
            case 'clearing':
                return 'Clearing any old data';
            case 'pending':
                return 'Waiting for last table to complete';
        }
    };
    return StatePipe;
}());
export { StatePipe };
var TableNamePipe = /** @class */ (function () {
    function TableNamePipe() {
    }
    TableNamePipe.prototype.transform = function (value) {
        return normalizeString(value).replace('Defs', 'Definitions');
    };
    return TableNamePipe;
}());
export { TableNamePipe };
